import { render, staticRenderFns } from "./CodeHighlight.vue?vue&type=template&id=e0295a22&scoped=true&"
import script from "./CodeHighlight.vue?vue&type=script&lang=js&"
export * from "./CodeHighlight.vue?vue&type=script&lang=js&"
import style0 from "./CodeHighlight.vue?vue&type=style&index=0&id=e0295a22&prod&lang=scss&scoped=true&"
import style1 from "./CodeHighlight.vue?vue&type=style&index=1&id=e0295a22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0295a22",
  null
  
)

export default component.exports